import { AxiosResponse } from "axios";
import AxiosInstance from "../utils/axiosConfig";

const ROOT = window.location.origin === "http://localhost:3000"
    ? "http://localhost:8080"
    : window.location.origin;

type captchaResponse = {
    siteKey: string;
}

export const getCaptchaKey = async (): Promise<string> => {
    const response: AxiosResponse<captchaResponse> = await AxiosInstance.get(
        `${ROOT}/o/location/v1.0/captcha/site-key`
    );
    return response.data.siteKey;
};